// extracted by mini-css-extract-plugin
export default {"feedback":"feedback_feedback__5tUY0","feedback_frame":"feedback_feedback_frame__tkPM6"};